export const catalog = [
  {
    id: "cf-tyue",
    title: "长风渡月",
    type: "剧集",
    genres: ["古装", "权谋"],
    region: "中国大陆",
    year: 2025,
    rating: 8.6,
    quality: "蓝光4K",
    tags: ["口碑热播", "更新中", "服化道精良"],
    episodes: "更新至 32 集 / 共 40 集",
    duration: "单集约 45 分钟",
    summary:
      "架空王朝中，寒门策士在朝堂与边关之间周旋，一步步揭开当年旧案的真相。服化道考据扎实，群像戏铺陈克制，适合喜欢慢热权谋线的观众。",
    featuredSeries: true,
    featuredMovie: false,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20key%20art%20for%20an%20ancient%20Chinese%20palace%20intrigue%20drama%2C%20ornate%20lantern-lit%20hall%20silhouettes%2C%20warm%20amber%20and%20deep%20vermilion%20palette%2C%20dramatic%20side%20light%2C%20textured%20minimalist%20backdrop%2C%20high%20detail%2C%20film%20grain%2C%20no%20text&width=400&height=600&seq=cat-cf-tyue&orientation=portrait",
  },
  {
    id: "wg-ma",
    title: "雾港迷案",
    type: "剧集",
    genres: ["悬疑", "刑侦"],
    region: "中国大陆",
    year: 2025,
    rating: 8.3,
    quality: "1080P",
    tags: ["单元案", "烧脑"],
    episodes: "更新至 18 集 / 共 24 集",
    duration: "单集约 40 分钟",
    summary:
      "常年被雾气笼罩的港口小城接连发生旧案翻案，刑警与法医在层层线索中追查同一枚指印。案件之间暗线交错，适合一集一个悬念地跟播。",
    featuredSeries: true,
    featuredMovie: false,
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20cinematic%20poster%20for%20a%20foggy%20harbor%20crime%20mystery%20series%2C%20misty%20docks%20and%20lone%20figure%20silhouette%2C%20desaturated%20teal%20green%20with%20warm%20amber%20highlights%2C%20dramatic%20volumetric%20light%2C%20minimalist%20textured%20backdrop%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=cat-wg-ma&orientation=portrait",
  },
  {
    id: "sh-sy",
    title: "山海拾遗录",
    type: "动漫",
    genres: ["奇幻", "冒险"],
    region: "中国大陆",
    year: 2025,
    rating: 8.1,
    quality: "蓝光4K",
    tags: ["国漫", "治愈画风"],
    episodes: "更新至 12 集 / 共 26 集",
    duration: "单集约 24 分钟",
    summary:
      "少年捡到一册会自己翻页的残卷，从此踏上寻访山海旧闻的旅程。作画笔触细腻，配色温柔，是国漫里难得兼顾热血与留白的作品。",
    featuredSeries: true,
    featuredMovie: false,
    poster:
      "https://readdy.ai/api/search-image?query=Fantasy%20adventure%20anime%20poster%20with%20floating%20mountain%20islands%20and%20glowing%20mythical%20creatures%2C%20warm%20golden%20and%20jade%20green%20palette%2C%20epic%20dramatic%20lighting%2C%20painterly%20textured%20minimalist%20background%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=cat-sh-sy&orientation=portrait",
  },
  {
    id: "sl-bj",
    title: "深蓝边界",
    type: "剧集",
    genres: ["科幻", "悬疑"],
    region: "欧美",
    year: 2025,
    rating: 8.4,
    quality: "蓝光4K",
    tags: ["限定剧", "已完结"],
    episodes: "全 6 集 · 已完结",
    duration: "单集约 55 分钟",
    summary:
      "深海观测站收到一段来自五十年前的信号，六名队员必须在补给船抵达前判断：他们究竟在观测海洋，还是被海洋观测。限定剧体量，适合一个周末看完。",
    featuredSeries: true,
    featuredMovie: false,
    poster:
      "https://readdy.ai/api/search-image?query=Sci-fi%20mystery%20series%20poster%20with%20a%20vast%20deep%20ocean%20horizon%20and%20futuristic%20station%20silhouette%2C%20warm%20amber%20accent%20light%20against%20cool%20tones%2C%20dramatic%20atmosphere%2C%20minimalist%20textured%20backdrop%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=cat-sl-bj&orientation=portrait",
  },
  {
    id: "qh-xt",
    title: "青禾学堂",
    type: "剧集",
    genres: ["青春", "校园"],
    region: "中国大陆",
    year: 2024,
    rating: 7.9,
    quality: "1080P",
    tags: ["轻喜剧", "群像"],
    episodes: "全 24 集 · 已完结",
    duration: "单集约 35 分钟",
    summary:
      "县城高中最后一届文科班，一群少年在升学压力与少年心事之间横冲直撞。台词接地气，笑点密集，结尾收得不煽情。",
    featuredSeries: true,
    featuredMovie: false,
    poster:
      "https://readdy.ai/api/search-image?query=Bright%20youth%20campus%20story%20poster%20with%20sunlit%20classroom%20windows%20and%20bicycle%20silhouettes%2C%20fresh%20warm%20cream%20and%20soft%20green%20palette%2C%20gentle%20natural%20light%2C%20minimalist%20textured%20background%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=cat-qh-xt&orientation=portrait",
  },
  {
    id: "sj-yh",
    title: "市井烟火",
    type: "剧集",
    genres: ["都市", "生活"],
    region: "中国大陆",
    year: 2024,
    rating: 8.8,
    quality: "1080P",
    tags: ["生活流", "下饭剧"],
    episodes: "全 36 集 · 已完结",
    duration: "单集约 42 分钟",
    summary:
      "一条老街上的早餐铺、修表摊和花店，串起几户人家的四季日常。几乎没有强冲突，却把生活的褶皱拍得熨帖，最适合配饭慢慢看。",
    featuredSeries: true,
    featuredMovie: false,
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20urban%20slice-of-life%20poster%20with%20cozy%20city%20alley%20at%20dusk%2C%20steaming%20food%20stalls%20and%20lanterns%2C%20amber%20and%20terracotta%20palette%2C%20soft%20evening%20light%2C%20minimalist%20textured%20backdrop%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=cat-sj-yh&orientation=portrait",
  },
  {
    id: "gt-xh",
    title: "归途信号",
    type: "剧集",
    genres: ["家庭", "剧情"],
    region: "韩国",
    year: 2025,
    rating: 8.5,
    quality: "蓝光4K",
    tags: ["温情", "完结"],
    episodes: "全 16 集 · 已完结",
    duration: "单集约 60 分钟",
    summary:
      "一位常年跑长途的父亲与留在小镇的女儿，靠每周一次的电话维系关系。全剧几乎没有反派，冲突都来自沉默与误解，收尾相当克制。",
    featuredSeries: true,
    featuredMovie: false,
    poster:
      "https://readdy.ai/api/search-image?query=Emotional%20family%20drama%20poster%20with%20a%20quiet%20suburban%20street%20at%20twilight%20and%20warm%20window%20lights%2C%20soft%20amber%20and%20moss%20green%20palette%2C%20gentle%20mood%2C%20minimalist%20textured%20backdrop%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=cat-gt-xh&orientation=portrait",
  },
  {
    id: "yl-cg",
    title: "驿路长歌",
    type: "电影",
    genres: ["剧情", "公路"],
    region: "中国大陆",
    year: 2024,
    rating: 8.7,
    quality: "蓝光4K",
    tags: ["公路片", "长镜头"],
    episodes: "片长 118 分钟",
    duration: "118 分钟",
    summary:
      "退休的邮递员决定亲自把最后一封无法投递的信送到收件人手上，于是有了这段横穿戈壁的旅程。摄影大气，配乐克制，适合安静地独自观看。",
    featuredSeries: false,
    featuredMovie: true,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20road%20trip%20drama%20poster%20with%20an%20empty%20highway%20through%20golden%20plains%20and%20a%20lone%20car%2C%20warm%20dusty%20amber%20tones%2C%20wide%20dramatic%20light%2C%20minimalist%20textured%20backdrop%2C%20high%20detail%2C%20film%20grain%2C%20no%20text&width=400&height=600&seq=cat-yl-cg&orientation=portrait",
  },
  {
    id: "xx-zs",
    title: "雪线之上",
    type: "电影",
    genres: ["冒险", "纪实"],
    region: "中国大陆",
    year: 2025,
    rating: 8.9,
    quality: "蓝光4K",
    tags: ["高山", "真实改编"],
    episodes: "片长 104 分钟",
    duration: "104 分钟",
    summary:
      "一支民间登山队在雨季窗口期挑战未登峰，影片既拍攀登也拍下撤。雪山镜头极具冲击力，叙事重心落在人与队伍的判断上。",
    featuredSeries: false,
    featuredMovie: true,
    poster:
      "https://readdy.ai/api/search-image?query=Epic%20adventure%20documentary%20poster%20of%20snow%20covered%20mountain%20ridges%20under%20dawn%20light%2C%20cold%20white%20and%20warm%20gold%20contrast%2C%20dramatic%20scale%2C%20minimalist%20textured%20backdrop%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=cat-xx-zs&orientation=portrait",
  },
  {
    id: "zy-nh",
    title: "子夜霓虹",
    type: "电影",
    genres: ["犯罪", "悬疑"],
    region: "中国香港",
    year: 2024,
    rating: 8.2,
    quality: "1080P",
    tags: ["黑色电影", "反转"],
    episodes: "片长 126 分钟",
    duration: "126 分钟",
    summary:
      "雨夜里的一桩失窃案牵出整条地下链条，卧底警员必须在身份暴露前完成最后一次交易。港式黑色片味道很正，结局有二刷价值。",
    featuredSeries: false,
    featuredMovie: true,
    poster:
      "https://readdy.ai/api/search-image?query=Neo-noir%20crime%20thriller%20poster%20with%20rainy%20neon%20city%20street%20and%20lone%20silhouette%2C%20deep%20crimson%20and%20amber%20neon%20glow%2C%20dramatic%20reflections%2C%20minimalist%20textured%20backdrop%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=cat-zy-nh&orientation=portrait",
  },
  {
    id: "sg-kz",
    title: "拾光客栈",
    type: "电影",
    genres: ["温情", "剧情"],
    region: "中国大陆",
    year: 2023,
    rating: 8.5,
    quality: "HD高清",
    tags: ["治愈", "群像"],
    episodes: "片长 110 分钟",
    duration: "110 分钟",
    summary:
      "古镇上一家只接待“走累了的人”的老客栈，用几组过客的故事拼出一个冬天的暖意。节奏舒缓，适合周末陪家人一起看。",
    featuredSeries: false,
    featuredMovie: true,
    poster:
      "https://readdy.ai/api/search-image?query=Gentle%20warm%20drama%20poster%20with%20a%20cozy%20old%20guesthouse%20courtyard%20and%20soft%20lantern%20light%2C%20honey%20amber%20and%20terracotta%20palette%2C%20nostalgic%20soft%20lighting%2C%20minimalist%20textured%20backdrop%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=cat-sg-kz&orientation=portrait",
  },
  {
    id: "hy-sw",
    title: "荒原守望者",
    type: "电影",
    genres: ["科幻", "末世"],
    region: "欧美",
    year: 2025,
    rating: 8.0,
    quality: "蓝光4K",
    tags: ["硬科幻", "慢节奏"],
    episodes: "片长 132 分钟",
    duration: "132 分钟",
    summary:
      "在资源枯竭的荒原上，一名孤独的信号维护员守着早已无人回应的电台。全片台词不多，靠影像与环境声撑起末世气氛。",
    featuredSeries: false,
    featuredMovie: true,
    poster:
      "https://readdy.ai/api/search-image?query=Post-apocalyptic%20sci-fi%20poster%20with%20a%20lone%20guardian%20figure%20on%20a%20vast%20wasteland%20under%20giant%20sky%2C%20muted%20amber%20and%20grey%20green%20tones%2C%20dramatic%20light%2C%20minimalist%20textured%20backdrop%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=cat-hy-sw&orientation=portrait",
  },
  {
    id: "cg-ys",
    title: "茶馆轶事",
    type: "电影",
    genres: ["年代", "剧情"],
    region: "中国大陆",
    year: 2024,
    rating: 8.6,
    quality: "1080P",
    tags: ["年代戏", "群像"],
    episodes: "片长 121 分钟",
    duration: "121 分钟",
    summary:
      "一间老茶馆横跨数十年，几代茶客来来去去，掌柜始终守着那张八仙桌。以小见大，时代变迁都藏在茶碗与闲谈里。",
    featuredSeries: false,
    featuredMovie: true,
    poster:
      "https://readdy.ai/api/search-image?query=Vintage%20period%20drama%20poster%20of%20an%20old%20teahouse%20interior%20with%20warm%20paper%20lanterns%20and%20wooden%20beams%2C%20sepia%20amber%20palette%2C%20nostalgic%20cinematic%20light%2C%20minimalist%20textured%20backdrop%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=cat-cg-ys&orientation=portrait",
  },
  {
    id: "dq-lr",
    title: "沙丘旅人",
    type: "电影",
    genres: ["文艺", "爱情"],
    region: "法国",
    year: 2024,
    rating: 8.1,
    quality: "HD高清",
    tags: ["文艺片", "异域"],
    episodes: "片长 98 分钟",
    duration: "98 分钟",
    summary:
      "两个在沙漠公路边错过彼此的人，用一整年时间重新走回同一条路。对白稀少，画面极美，适合喜欢慢节奏文艺片的观众。",
    featuredSeries: false,
    featuredMovie: true,
    poster:
      "https://readdy.ai/api/search-image?query=Artistic%20romance%20film%20poster%20with%20a%20windswept%20desert%20dune%20and%20two%20distant%20silhouettes%2C%20warm%20sand%20and%20rose%20amber%20tones%2C%20poetic%20light%2C%20minimalist%20textured%20backdrop%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=cat-dq-lr&orientation=portrait",
  },
  {
    id: "cs-mb",
    title: "城市脉搏",
    type: "纪录片",
    genres: ["社会", "纪实"],
    region: "中国大陆",
    year: 2024,
    rating: 9.0,
    quality: "1080P",
    tags: ["纪实影像", "全季完结"],
    episodes: "全 8 集 · 已完结",
    duration: "单集约 50 分钟",
    summary:
      "把镜头对准夜班公交司机、清晨分拣员和凌晨的医院走廊，记录一座城市在多数人睡着时的样子。适合当背景音，也适合静下心来看。",
    featuredSeries: false,
    featuredMovie: false,
    poster:
      "https://readdy.ai/api/search-image?query=Documentary%20poster%20of%20city%20life%20at%20night%2C%20time%20exposure%20traffic%20light%20trails%20and%20skyline%2C%20warm%20amber%20and%20green%20tones%2C%20cinematic%20urban%20mood%2C%20minimalist%20textured%20backdrop%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=cat-cs-mb&orientation=portrait",
  },
  {
    id: "xy-st",
    title: "星野食堂",
    type: "综艺",
    genres: ["美食", "治愈"],
    region: "中国大陆",
    year: 2025,
    rating: 8.3,
    quality: "HD高清",
    tags: ["慢综艺", "更新中"],
    episodes: "更新至第 9 期 / 共 12 期",
    duration: "单期约 70 分钟",
    summary:
      "几位厨师把厨房搬到草原、海边和雪山脚下，就地取材做一桌饭。没有竞技，只有食材和火候，适合吃饭时当背景。",
    featuredSeries: false,
    featuredMovie: false,
    poster:
      "https://readdy.ai/api/search-image?query=Cozy%20food%20variety%20show%20poster%20with%20a%20rustic%20outdoor%20kitchen%20under%20starry%20sky%2C%20warm%20campfire%20glow%2C%20appetizing%20dishes%2C%20amber%20and%20green%20palette%2C%20minimalist%20textured%20backdrop%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=cat-xy-st&orientation=portrait",
  },
];